import {Brick, registerBrick} from 'olympe';

/**
 * @typedef AttachmentToSend
 * @type {Object}
 * @property {'main'|'competitive'} type
 * @property {string} fileId
 * @property {string} fileName
 * @property {string} topic
 */


export default class GetAttachmentsFromPR extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} pRJson
     * @param {function(ListDef)} setAttachments
     */
    update($, [pRJson], [setAttachments]) {
        // Write your code here. You have to implement this method !
        // Executed every time an input gets updated., override `setupExecution()` to change the behavior.

        setAttachments(this.prepareAttachments(pRJson));
    }

    /**
     * Parse the PR and return an array of {AttachmentToSend} ready to be sent
     *
     * @private
     * @param {string} prJSON
     * @return {AttachmentToSend[]}
     */
    prepareAttachments(prJSON) {
        try {
            const parsedPR = JSON.parse(prJSON);
            const mainAttachments = Array.isArray(parsedPR.attachmentsInfo.mainAttachments) ? parsedPR.attachmentsInfo.mainAttachments : [];
            const competitiveAttachments = Array.isArray(parsedPR.attachmentsInfo.competitiveBiddingJustificationAttachments) ? parsedPR.attachmentsInfo.competitiveBiddingJustificationAttachments : [];
            const attachments = [];

            for (const mainAttachment of mainAttachments) {
                attachments.push(this.prepareAttachment('main', mainAttachment));
            }

            for (const competitiveAttachment of competitiveAttachments) {
                attachments.push(this.prepareAttachment('competitive', competitiveAttachment));
            }

            return attachments;
        } catch (e) {
            return [];
        }
    }

    /**
     * @private
     * @param {'main'|'competitive'} type
     * @param {object} data
     * @return {AttachmentToSend}
     */
    prepareAttachment(type, data) {
        return {
            fileId: data.file,
            fileName: data.name,
            topic: data.topic,
            type,
            fileCreator: data.userId,
        };
    }
}

registerBrick('0181155f04ff23892d93', GetAttachmentsFromPR);
